import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostListener,
  Input
} from '@angular/core';
import { RadioComponent } from '../../../radio/radio.component';

@Component({
  selector: 'lp2-teacher-switch-selection-box',
  templateUrl: './teacher-switch-selection-box.component.html',
  styleUrls: ['./teacher-switch-selection-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.teacher-switch-selection-box--checked]': 'isChecked',
  },
})
export class TeacherSwitchSelectionBoxComponent {
  @ContentChild(RadioComponent) private _radioComponent: RadioComponent;

  @Input() public title: string;

  @Input() public description: string;

  @Input() public iconPath: string;

  @Input() public isRecommended: boolean;

  public get isChecked(): boolean {
    if (this._radioComponent) {
      return this._radioComponent.checked;
    }
  }

  @HostListener('click') public check() {
    if (this._radioComponent) {
      this._radioComponent.check();
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/teacher-switch/teacher-switch-modal/teacher-switch-selection-box/teacher-switch-selection-box.component.ts